const useChangeClientPasswordForm = () => {
  const { t } = useI18n();
  const { loading, mutate, onDone, onError } = useChangeClientPasswordDto();

  const { defineField, errors, handleSubmit, meta, resetForm, setErrors } = useForm<ChangeClientPasswordForm>({
    validationSchema: toTypedSchema(CHANGE_CLIENT_PASSWORD_SCHEMA),
  });

  const fields: ChangeClientPasswordFields = {
    new_password: defineField("new_password", {
      validateOnModelUpdate: false,
    }),
    new_password_repeat: defineField("new_password_repeat", {
      validateOnModelUpdate: false,
    }),
    old_password: defineField("old_password"),
  };

  const submit = handleSubmit(async (formData) => {
    await mutate(formData);
  });

  onDone(async () => {
    await useRefetchClient();

    const { openNotification } = useNotificationStore();

    resetForm();
    openNotification(t("notifications.passwordSaveSuccess"));
  });

  onError(() => {
    setErrorsFields.graphql(setErrors, onError);
  });

  return {
    errors,
    fields,
    handleSubmit: submit,
    loading,
    meta,
  };
};

export { useChangeClientPasswordForm };
